import { view } from '@yola/ws-sdk';
import createCompositeItem from './create-composite-item';
import createCompositeGroup from './create-composite-group';
import calculateNewItemPosition from './calculate-new-item-position';
import getElementSizes from './get-element-sizes';
import calculateCreationSequence from './calculate-creation-sequence';

function addAndConvertToGroup({ elementId }) {
  const staticNode = view.accessors.getStaticElement(elementId);
  const liveNode = view.accessors.getLiveElement(elementId);
  const singleMedia = staticNode.cloneNode(true);
  const slotName = singleMedia.getAttribute('slot') || null;
  const { aspectRatio } = getElementSizes(liveNode);
  const mediaGroupId = singleMedia.getAttribute('media-group-id');
  const widthValue = singleMedia.getAttribute('width');

  singleMedia.removeAttribute('slot');
  singleMedia.removeAttribute('width');
  singleMedia.removeAttribute('media-group-id');

  const compositionGroup = createCompositeGroup({
    slot: slotName,
    aspectRatio,
    width: widthValue,
    mediaGroupId,
  });

  const itemWithExistingImage = createCompositeItem({
    childNode: singleMedia,
    position: '50% 50%',
    aspectRatio,
    stretched: true,
  });

  compositionGroup.appendChild(itemWithExistingImage);

  const newCompositionItem = createCompositeItem({
    position: calculateNewItemPosition(compositionGroup),
    dataCreationSequence: calculateCreationSequence(compositionGroup),
  });

  compositionGroup.appendChild(newCompositionItem);
  view.operations.replaceElement(compositionGroup, elementId);
}

export default addAndConvertToGroup;
